import type {RichTextField, RTNode} from '@prismicio/client'

/**
 * Helper to extract text segments from Prismic rich text with their formatting
 * Returns segments with text content and bold formatting information
 */
export const extractTextSegments = (richText: RichTextField): Array<{text: string; isBold: boolean}> => {
  const segments: Array<{text: string; isBold: boolean}> = []

  // Iterate through each Prismic rich text block (paragraphs, headings, etc.)
  richText.forEach((block: RTNode, blockIndex) => {
    if ('text' in block && block.text) {
      if ('spans' in block && block.spans && block.spans.length > 0) {
        let currentPos = 0

        block.spans.forEach((span) => {
          // Add text before span
          if (span.start > currentPos) {
            segments.push({text: block.text.slice(currentPos, span.start), isBold: false})
          }

          // Add span text
          segments.push({
            text: block.text.slice(span.start, span.end),
            isBold: span.type === 'strong',
          })

          currentPos = span.end
        })

        // Add remaining text
        if (currentPos < block.text.length) {
          segments.push({text: block.text.slice(currentPos), isBold: false})
        }
      } else {
        segments.push({text: block.text, isBold: false})
      }

      // Add line break after each block (except the last one)
      if (blockIndex < richText.length - 1) {
        segments.push({text: '\n', isBold: false})
      }
    }
  })

  return segments
}
